import { render, staticRenderFns } from "./NearbyPlacesModal.vue?vue&type=template&id=057cad5d&scoped=true"
import script from "./NearbyPlacesModal.vue?vue&type=script&lang=ts"
export * from "./NearbyPlacesModal.vue?vue&type=script&lang=ts"
import style0 from "./NearbyPlacesModal.vue?vue&type=style&index=0&id=057cad5d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057cad5d",
  null
  
)

export default component.exports